<template>
<v-container>
  <v-col cols="12">
    <v-row
      align="center"
      justify="center"
      class="grey lighten-5"
      style="height: 300px;"
    >
      <v-card class="ma-3 pa-6" outlined text>
        <div class="page-title mb-6">
          <h2 class="headline text-center">Välkommen!</h2>
        </div>
        <v-text-field
          v-model="userName"
          label="Skriv ditt namn ..."
          outlined
        ></v-text-field>
        <v-btn
          @click="addUser"
          @on:keyup.enter="addUser"
          color="success"
          :disabled="validNameLength">Jag vill smaka öl och rösta</v-btn>
      </v-card>
    </v-row>
  </v-col>
</v-container>
</template>
<script>
import myMixin from '../mixins'

export default {
  mixins: [myMixin],
  data () {
    return {
      userName: ''
    }
  },
  computed: {
    validNameLength () {
      return this.userName.length < 2
    }
  },
  methods: {
    addUser () {
      this.$store.dispatch('setRaterName', this.userName)
      this.setCookie('3ol3', 'userName=' + this.userName, 666)
    }
  }
}
</script>
